import {Injectable} from '@angular/core';
import {ApiImplementation} from '../api/api-implementation.service';
import {ApiService} from '../api/api.service';
import {Paginator} from '../../models/paginator';
import {Group} from '../../models/group';
import {Builder} from '../../models/builder';
import {Entity} from '../../models/entity';

@Injectable({
  providedIn: 'root',
})
export class GroupsService extends ApiImplementation {

  protected base: string = 'v1/groups';
  protected primaryKey: string = 'id';

  constructor(protected api: ApiService) {
    super(api)
  }

  model(data?) {
    return new Group(data);
  }

  paginator(data) {
    return new Paginator<Group>(data);
  }


  // public groups(group : Group){
  //   return this.api.get(this.base + '/' + group.id + '/groups').then( data => {
  //     return this.groupService.transform(data['data']);
  //   })
  // }
  //

  public all(limit = 100, page = 1): Promise<Paginator<Group>> {
    return super.all(limit, page) as Promise<Paginator<Group>>;
  }

  /**
   * No limits!
   * @param builder
   * @return Array<Group>
   */

  public allgroups() {
    return this.api.get(this.base + '/all');
  }

  public everything(builder: Builder = new Builder()) {
    return this.api.all(this.base, 1, [], '&' + builder.buildUrl());
  }

  public getEntities(id: number, builder: Builder = new Builder()) {
    return this.api.get(this.base + '/' + id + '/entities' + builder.buildUrl(true)) as Promise<any>;
  }

  public getEntitiesAll(id: number) {
    return this.api.all(this.base + '/' + id + '/entities') as Promise<any>;
  }

  public getEmployees(id: number) {
    return this.api.all(this.base + '/' + id + '/employees') as Promise<any>;
  }

  public getSchedule(id: number, builder: Builder = new Builder()) {
    return this.api.all(
      this.base + '/' + id + '/entities/schedule', 1, [],
      '&' + builder.buildUrl());
  }

  public get(id: number) {
    return super.get(id) as Promise<Group>;
  }

  public delete(group: Group) {
    return super.delete(group);
  }

  public save(group: Group): Promise<Group> {
    return super.save(group) as Promise<Group>;
  }

  public getFilteredCategories(id, category = null, minAge = 0, maxAge = 0) {
    let category_request = '';
    let age_request = '';

    if (category) {
      category_request = '&filter[category]=' + category;
    }

    if (minAge || maxAge) {
      age_request = '&filter[age]=' + maxAge + ',' + minAge;
    }

    return this.api.all(this.base + '/' + id + '/entities', 1, [], age_request + category_request) as Promise<any>;
  }
}
